var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-and-image-tile-content",style:({
    backgroundImage: _vm.image ? `var(--background-overlay), url('${ _vm.image }')` : null
  })},[(_vm.title)?_c('h1',{staticClass:"text-and-image-tile-content--title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"text-and-image-tile-content--text ck-editor",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }